export const VALID = 'valid';
export const INVALID = 'invalid';
